module.exports = __webpack_public_path__ + "img/contact-weixin.a50f8c42.jpg";